// React Dependencies
import React from 'react';

// External Dependencies
import PropTypes from 'prop-types';

// Internal Dependencies
import Colours from '../../styles/colours';

const StatusBadge = (props) => (
  <span
    style={{
      padding:      '4px 10px',
      borderRadius: 4,
      fontWeight:   600,
      fontSize:     13,
      color:        props.isBanned ? Colours.Red1 : Colours.Green1,
      background:   props.isBanned ? '#ffebee' : '#e8f5e9',
    }}
  >
    {props.isBanned ? 'Banned' : 'Active'}
  </span>
);

StatusBadge.defaultProps = {
  isBanned: false,
};

StatusBadge.propTypes = {
  isBanned: PropTypes.bool,
};

export default StatusBadge;
